import { getFreespin } from '../api/getFreespin';

const setGetFreespin = (params, setCode) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getFreespin(params);

            if (data.status === 'success') {
                setCode(JSON.stringify(data.data))
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetFreespin
}